import {
  getUsersData,
  downloadUserData,
  getUserDetailData,
  listBatchUserData,
  validateBatchUserData,
  batchUserImportFileData,
  downloadQrCodeData,
  validateBatchUpdateUserData,
  batchUserImportUpdateFileData,
  getUserTokenData,
  getListUserKidCanUseData,
  getListUserKidCanUseGroupSpecialData,
  getListMessageSentToUserByAdminData,
  deleteMessageSentToUserByAdminData,
  addMessageAdminSendToUserData
} from '../libs/apis/UserApi';

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const DOWNLOAD_USER_REQUEST = 'DOWNLOAD_USER_REQUEST';
export const DOWNLOAD_USER_SUCCESS = 'DOWNLOAD_USER_SUCCESS';
export const DOWNLOAD_USER_FAILURE = 'DOWNLOAD_USER_FAILURE';

export const GET_USER_DETAIL_REQUEST = 'GET_USER_DETAIL_REQUEST';
export const GET_USER_DETAIL_SUCCESS = 'GET_USER_DETAIL_SUCCESS';
export const GET_USER_DETAIL_FAILURE = 'GET_USER_DETAIL_FAILURE';

export const GET_BATCH_USER_REQUEST = 'GET_BATCH_USER_REQUEST';
export const GET_BATCH_USER_SUCCESS = 'GET_BATCH_USER_SUCCESS';
export const GET_BATCH_USER_FAILURE = 'GET_BATCH_USER_FAILURE';

export const VALIDATE_BATCH_USER_REQUEST = 'VALIDATE_BATCH_USER_REQUEST';
export const VALIDATE_BATCH_USER_SUCCESS = 'VALIDATE_BATCH_USER_SUCCESS';
export const VALIDATE_BATCH_USER_FAILURE = 'VALIDATE_BATCH_USER_FAILURE';

export const ADD_BATCH_USER_IMPORT_FILE_REQUEST =
  'ADD_BATCH_USER_IMPORT_FILE_REQUEST';
export const ADD_BATCH_USER_IMPORT_FILE_SUCCESS =
  'ADD_BATCH_USER_IMPORT_FILE_SUCCESS';
export const ADD_BATCH_USER_IMPORT_FILE_FAILURE =
  'ADD_BATCH_USER_IMPORT_FILE_FAILURE';

export const DOWNLOAD_QRCODE_REQUEST = 'DOWNLOAD_QRCODE_REQUEST';
export const DOWNLOAD_QRCODE_SUCCESS = 'DOWNLOAD_QRCODE_SUCCESS';
export const DOWNLOAD_QRCODE_FAILURE = 'DOWNLOAD_QRCODE_FAILURE';

export const GET_USER_TOKEN_REQUEST = 'GET_USER_TOKEN_REQUEST';
export const GET_USER_TOKEN_SUCCESS = 'GET_USER_TOKEN_SUCCESS';
export const GET_USER_TOKEN_FAILURE = 'GET_USER_TOKEN_FAILURE';

export const GET_LIST_USER_KID_CAN_USE_REQUEST =
  'GET_LIST_USER_KID_CAN_USE_REQUEST';
export const GET_LIST_USER_KID_CAN_USE_SUCCESS =
  'GET_LIST_USER_KID_CAN_USE_SUCCESS';
export const GET_LIST_USER_KID_CAN_USE_FAILURE =
  'GET_LIST_USER_KID_CAN_USE_FAILURE';

export const GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_REQUEST =
  'GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_REQUEST';
export const GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_SUCCESS =
  'GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_SUCCESS';
export const GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_FAILURE =
  'GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_FAILURE';

export const GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_REQUEST =
  'GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_REQUEST';
export const GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS =
  'GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS';
export const GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE =
  'GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE';

export const DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_REQUEST =
  'DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_REQUEST';
export const DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS =
  'DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS';
export const DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE =
  'DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE';

export const ADD_MESSAGE_ADMIN_SEND_TO_USER_REQUEST =
  'ADD_MESSAGE_ADMIN_SEND_TO_USER_REQUEST';
export const ADD_MESSAGE_ADMIN_SEND_TO_USER_SUCCESS =
  'ADD_MESSAGE_ADMIN_SEND_TO_USER_SUCCESS';
export const ADD_MESSAGE_ADMIN_SEND_TO_USER_FAILURE =
  'ADD_MESSAGE_ADMIN_SEND_TO_USER_FAILURE';

export const getUsers = params => dispatch => {
  dispatch({ type: GET_USERS_REQUEST });
  return getUsersData(params)
    .then(response =>
      dispatch({
        type: GET_USERS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_USERS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadUser = params => dispatch => {
  dispatch({ type: DOWNLOAD_USER_REQUEST });
  return downloadUserData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_USER_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_USER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getUserDetail = userId => dispatch => {
  dispatch({ type: GET_USER_DETAIL_REQUEST });
  return getUserDetailData(userId)
    .then(response =>
      dispatch({
        type: GET_USER_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error => {
      dispatch({
        type: GET_USER_DETAIL_FAILURE,
        payload: error.response,
        error: true
      });
    });
};

export const listBatchUser = params => dispatch => {
  dispatch({ type: GET_BATCH_USER_REQUEST });
  return listBatchUserData(params)
    .then(response =>
      dispatch({
        type: GET_BATCH_USER_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BATCH_USER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const validateBatchUser = params => dispatch => {
  dispatch({ type: VALIDATE_BATCH_USER_REQUEST });
  return validateBatchUserData(params)
    .then(response =>
      dispatch({
        type: VALIDATE_BATCH_USER_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: VALIDATE_BATCH_USER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const batchUserImportFile = params => dispatch => {
  dispatch({ type: ADD_BATCH_USER_IMPORT_FILE_REQUEST });
  return batchUserImportFileData(params)
    .then(response =>
      dispatch({
        type: ADD_BATCH_USER_IMPORT_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_BATCH_USER_IMPORT_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const validateBatchUpdateUser = params => dispatch => {
  dispatch({ type: VALIDATE_BATCH_USER_REQUEST });
  return validateBatchUpdateUserData(params)
    .then(response =>
      dispatch({
        type: VALIDATE_BATCH_USER_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: VALIDATE_BATCH_USER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const batchUserImportUpdateFile = params => dispatch => {
  dispatch({ type: ADD_BATCH_USER_IMPORT_FILE_REQUEST });
  return batchUserImportUpdateFileData(params)
    .then(response =>
      dispatch({
        type: ADD_BATCH_USER_IMPORT_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_BATCH_USER_IMPORT_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadQrCode = (shopId, suffixes) => dispatch => {
  dispatch({ type: DOWNLOAD_QRCODE_REQUEST });
  return downloadQrCodeData(shopId, suffixes)
    .then(response =>
      dispatch({
        type: DOWNLOAD_QRCODE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_QRCODE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getUserToken = data => dispatch => {
  dispatch({ type: GET_USER_TOKEN_REQUEST });
  return getUserTokenData(data)
    .then(response =>
      dispatch({
        type: GET_USER_TOKEN_SUCCESS,
        payload: response
      })
    )
    .catch(error =>
      dispatch({
        type: GET_USER_TOKEN_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getListUserKidCanUse = params => dispatch => {
  dispatch({ type: GET_LIST_USER_KID_CAN_USE_REQUEST });
  return getListUserKidCanUseData(params)
    .then(response =>
      dispatch({
        type: GET_LIST_USER_KID_CAN_USE_SUCCESS,
        payload: response
      })
    )
    .catch(error =>
      dispatch({
        type: GET_LIST_USER_KID_CAN_USE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getListUserKidCanUseGroupSpecial = params => dispatch => {
  dispatch({ type: GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_REQUEST });
  return getListUserKidCanUseGroupSpecialData(params)
    .then(response =>
      dispatch({
        type: GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_SUCCESS,
        payload: response
      })
    )
    .catch(error =>
      dispatch({
        type: GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getListMessageSentToUserByAdmin = params => dispatch => {
  dispatch({ type: GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_REQUEST });
  return getListMessageSentToUserByAdminData(params)
    .then(response =>
      dispatch({
        type: GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS,
        payload: response
      })
    )
    .catch(error =>
      dispatch({
        type: GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteMessageSentToUserByAdmin = params => dispatch => {
  dispatch({ type: DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_REQUEST });
  return deleteMessageSentToUserByAdminData(params)
    .then(response =>
      dispatch({
        type: DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS,
        payload: response
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addMessageAdminSendToUser = params => dispatch => {
  dispatch({ type: ADD_MESSAGE_ADMIN_SEND_TO_USER_REQUEST });
  return addMessageAdminSendToUserData(params)
    .then(response =>
      dispatch({
        type: ADD_MESSAGE_ADMIN_SEND_TO_USER_SUCCESS,
        payload: response
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_MESSAGE_ADMIN_SEND_TO_USER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
